/**
 * Gallery search params (FR-FE09-19: `?category=&all=1`). Kept apart from the filter logic because
 * route files load with the route tree (entry chunk), while the gallery itself is a lazy chunk.
 */
export interface TemplatesSearch {
  category?: string;
  all?: 1;
}

export function parseTemplatesSearch(search: Record<string, unknown>): TemplatesSearch {
  const out: TemplatesSearch = {};
  if (typeof search.category === "string" && search.category) out.category = search.category;
  if (search.all === 1 || search.all === "1" || search.all === true) out.all = 1;
  return out;
}
